import { ShowDataFor } from 'utils/components/ShowDataFor/ShowDataFor';

export type SymbolTileView = 'chart' | 'values';

export interface SymbolTileConfigState {
    symbol?: string;
    view: SymbolTileView;
    showDataFor?: ShowDataFor;
}

export const initialSymbolTileConfigState: SymbolTileConfigState = {
    view: 'chart',
    showDataFor: ShowDataFor.AllDay,
};
